import React, { PureComponent } from 'react';
import { Provider } from 'react-redux';

import setup from './setup';
import configureStore from './store/configureStore';
import App from './App';

class Root extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      store: configureStore(this.onLoadStore)
    };
  }

  onLoadStore = async () => {
    const { store } = this.state;
    await setup(store);
    this.setState({ isLoading: false });
  };

  render() {
    if (this.state.isLoading) return <p>Carregando</p>;

    return (
      <Provider store={this.state.store}>
        <App />
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js